import { put, call } from "redux-saga/effects";
import { SAVE_ATTORNEYINFO_SUCESS,SAVE_ATTORNEYINFO_FAILED,UPDATE_ATTORNEYDETAILS_SUCCESS, UPDATE_ATTORNEYDETAILS_FAILED,
    GET_ATTORNEYINFO_SUCESS,GET_ATTORNEYINFO_FAILED ,GET_ATTORNEYDETAILS_SUCESS, GET_ATTORNEYDETAILS_FAILED ,

    SAVE_G28FORM_SUCESS,SAVE_G28FORM_FAILED,UPDATE_G28FORM_SUCCESS, UPDATE_G28FORM_FAILED,
    GET_G28FORM_SUCESS,GET_G28FORM_FAILED ,

    GENERATE_G28FORM_SUCCESS,GENERATE_G28FORM_FAILED


 
} from "../actions/AddAttorney";
import { AddAttorneyAPI } from "../../utils/api/AddAttorneyAPI";

export function*getallAttorneyDetails (request:any) {
    try {
        const { data } = yield call(AddAttorneyAPI.getallAttorneyDetails,request);
  
      yield put({
          type: GET_ATTORNEYINFO_SUCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_ATTORNEYINFO_FAILED, payload: e.message });
    }
}
export function* saveAttorneyDetails(request: any) {
  //  alert("sagas");
    try {
           const result=yield call(AddAttorneyAPI.saveAttorneyDetails, request.input);
         yield put({ 
            type: SAVE_ATTORNEYINFO_SUCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_ATTORNEYINFO_FAILED, payload: e.message });
    }
}
export function*getAttorneyDetailsByCompanyId (request:any) {
    try {
        const { data } = yield call(AddAttorneyAPI.getAttorneyDetailsByCompanyId,request);
  
      yield put({
          type: GET_ATTORNEYDETAILS_SUCESS,
          payload: data 
        });
    } catch (e) {
        yield put({ type: GET_ATTORNEYDETAILS_FAILED, payload: e.message });
    }
}

export function* updateAttorneyDetailsInput(request: any) {
  
    try {
           const result=yield call(AddAttorneyAPI.updateAttorneyDetailsInput, request.input);
         yield put({ 
            type: UPDATE_ATTORNEYDETAILS_SUCCESS,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: UPDATE_ATTORNEYDETAILS_FAILED, payload: e.message });
    }
}


export function* createCaseFlowg28(request: any) {
 
      try {
             const result=yield call(AddAttorneyAPI.createCaseFlowg28, request.input);
           yield put({ 
              type: SAVE_G28FORM_SUCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: SAVE_G28FORM_FAILED, payload: e.message });
      }
  }
  export function*getCaseFlowG28ByCaseId (request:any) {
      try {
          const { data } = yield call(AddAttorneyAPI.getCaseFlowG28ByCaseId,request);
    
        yield put({
            type: GET_G28FORM_SUCESS,
            payload: data 
          });
      } catch (e) {
          yield put({ type: GET_G28FORM_FAILED, payload: e.message });
      }
  }
  
  export function* updateCaseFlowg28(request: any) {
    
      try {
             const result=yield call(AddAttorneyAPI.updateCaseFlowg28, request.input);
           yield put({ 
              type: UPDATE_G28FORM_SUCCESS,     
              payload: result.data,
              input: request.input
          });
      } catch (e) {
          yield put({ type: UPDATE_G28FORM_FAILED, payload: e.message });
      }
  }

  export function* g28PdfGenerationNew(request: any) {
    
    try {
 
           const result=yield call(AddAttorneyAPI.g28PdfGenerationNew, request.input);
         yield put({ 
            type: GENERATE_G28FORM_SUCCESS,     
            payload: result.data ,
            input: request.input
        });
    } catch (e) {
        yield put({ type: GENERATE_G28FORM_FAILED, payload: e.message });
    }
}